import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.jpg';
import { supabase } from '../lib/supabaseClient';

// Map section keys to nav labels
const allLinks = [
  { label:'Home',         href:'#home',         key:null },
  { label:'About',        href:'#about',         key:'about' },
  { label:'Pastors',      href:'#pastors',       key:'pastors' },
  { label:'Services',     href:'#services',      key:'services' },
  { label:'Events',       href:'#events',        key:'events' },
  { label:'Sermons',      href:'#sermons',       key:'sermons' },
  { label:'Gallery',      href:'#gallery',       key:'gallery' },
  { label:'Testimonials', href:'#testimonials',  key:'testimonials' },
  { label:'Branches',     href:'#branches',      key:'branches' },
  { label:'Prayer',       href:'#prayer',        key:'prayer' },
  { label:'Give',         href:'#give',          key:'give' },
  { label:'Connect',      href:'#connect',       key:'connect' },
];

const socials = [
  { label:'YouTube',   href:'https://youtube.com/@zionaogooty' },
  { label:'Facebook',  href:'https://www.facebook.com/share/1HL7j1WzfT/' },
  { label:'Instagram', href:'https://www.instagram.com/zionagooty' },
  { label:'WhatsApp',  href:'https://wa.me/917397547474' },
];

export default function Footer() {
  const [vis, setVis] = useState({});
  const [contact, setContact] = useState({ phone:'+91 73975 47474', email:'zionaog.fernhill@gmail.com', phoneEnabled:true, emailEnabled:true });

  useEffect(() => {
    supabase.from('church_settings').select('key,value')
      .then(({ data }) => {
        if (data) {
          const m = {};
          data.forEach(r => { m[r.key] = r.value; });
          setContact(prev => ({
            phone: m.church_phone || prev.phone,
            email: m.church_email || prev.email,
            phoneEnabled: m.church_phone_enabled !== 'false',
            emailEnabled: m.church_email_enabled !== 'false',
          }));
        }
      }).catch(() => {});
  }, []);

  useEffect(() => {
    supabase.from('section_visibility').select('key,enabled')
      .then(({ data }) => {
        if (data) { const m={}; data.forEach(r=>{m[r.key]=r.enabled;}); setVis(m); }
      }).catch(()=>{});
  }, []);

  const show = (key) => key === null ? true : (vis[key]===undefined ? true : Boolean(vis[key]));
  const visibleLinks = allLinks.filter(l => show(l.key));

  const gold = 'var(--primary)';
  const muted = 'rgba(200,191,168,0.65)';

  return (
    <footer style={{ background:'#020811', borderTop:'1px solid rgba(201,168,76,0.18)', padding:'60px 24px 28px' }}>
      <div style={{ maxWidth:1120, margin:'0 auto' }}>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:40, marginBottom:50 }}>

          {/* Brand */}
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:20 }}>
              <img src={logo} alt="Zion AG" style={{ width:56, height:56, objectFit:'contain', flexShrink:0, mixBlendMode:'screen' }} />
              <div>
                <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'0.78rem', color:gold, lineHeight:1.4 }}>
                  ZION ASSEMBLIES OF GOD
                </div>
                <div style={{ fontSize:'0.65rem', color:'rgba(201,168,76,0.6)', letterSpacing:'0.12em', marginTop:3 }}>
                  CHURCH — OOTY, TAMIL NADU
                </div>
              </div>
            </div>
            <p style={{ fontFamily:"'Crimson Pro',serif", fontStyle:'italic', fontSize:'0.95rem', color:'var(--text-muted)', lineHeight:1.7, marginBottom:16 }}>
              "Jesus Is Lord" — Philippians 2:11
            </p>
            <p style={{ fontSize:'0.78rem', color:'rgba(200,191,168,0.6)', lineHeight:1.6 }}>
              Near Gel Memorial School,<br />
              Church Road, Fernhill,<br />
              Ooty – 643004, Tamil Nadu<br />
              {contact.phoneEnabled && <a href={`tel:${contact.phone.replace(/[^0-9+]/g,"")}`} style={{ color:gold, textDecoration:'none' }}>📞 {contact.phone}</a>}
              {contact.emailEnabled && <div style={{marginTop:4}}><a href={`mailto:${contact.email}`} style={{ color:gold, textDecoration:'none' }}>📧 {contact.email}</a></div>}
            </p>
          </div>

          {/* Quick Links — hide disabled sections */}
          <div>
            <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'0.78rem', color:gold, letterSpacing:'0.12em', marginBottom:18 }}>
              Quick Links
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px 16px' }}>
              {visibleLinks.map(l => (
                <a key={l.href} href={l.href}
                  style={{ color:muted, textDecoration:'none', fontSize:'0.78rem', letterSpacing:'0.06em', transition:'color 0.2s' }}
                  onMouseEnter={e=>e.target.style.color=gold}
                  onMouseLeave={e=>e.target.style.color=muted}
                >
                  › {l.label}
                </a>
              ))}
            </div>
          </div>

          {/* Follow Us + Daily Prayer */}
          <div>
            <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'0.78rem', color:gold, letterSpacing:'0.12em', marginBottom:18 }}>
              Follow Us
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:12, marginBottom:28 }}>
              {socials.map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="noreferrer"
                  style={{ color:muted, textDecoration:'none', fontSize:'0.8rem', letterSpacing:'0.06em', transition:'color 0.2s' }}
                  onMouseEnter={e=>e.target.style.color=gold}
                  onMouseLeave={e=>e.target.style.color=muted}
                >
                  › {s.label}
                </a>
              ))}
            </div>
            <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'0.78rem', color:gold, letterSpacing:'0.12em', marginBottom:12 }}>
              Daily Prayer
            </div>
            <p style={{ fontSize:'0.78rem', color:muted, lineHeight:1.7 }}>
              10:00 AM — Every Single Day<br />
              365 Days a Year<br />
              All are welcome 🙏
            </p>
          </div>

        </div>

        {/* Bottom */}
        <div style={{ borderTop:'1px solid rgba(201,168,76,0.12)', paddingTop:24, textAlign:'center' }}>
          <div style={{ fontFamily:"'Crimson Pro',serif", fontStyle:'italic', color:'rgba(201,168,76,0.5)', fontSize:'0.88rem', marginBottom:10 }}>
            "To God be the glory, great things He hath done." — Fanny Crosby
          </div>
          <div style={{ fontSize:'0.7rem', color:'rgba(200,191,168,0.3)', letterSpacing:'0.06em' }}>
            © {new Date().getFullYear()} Zion Assemblies of God Church, Ooty. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
